<template>
  <div id="app" ref="scrollContainer">
    <div class="card">
      <div :class="[ fontMultiplier > 1.2 && userWidth < 600 ? 'd-block' : 'd-flex' ,' align-items-center card-header justify-content-between']">
        <div class="input-group mb-3">
          <button class="btn btn-search" type="button">
            <i class="bi bi-search"></i>
          </button>
          <input type="text" class="form-control border-0" placeholder="Pesquisar" v-model="search">
          <div class="input-group-append"></div>
        </div>
        <div :class="[ fontMultiplier > 1.2 && userWidth < 600 ? 'w-100  d-flex justify-content-end' : '']">
          <div class="btn-group ml-auto" v-if="getType === 'manager'">
            <button type="button" class="dropdown-toggle" @click="hideOrShowDropdown">
              {{ optionSelected }}
            </button>
            <div v-if="showDropdown" class="dropdown-menu" style="display: block;">
              <a class="dropdown-item" @click="filterUsers('Usuários', 'users')">Usuários</a>
              <a class="dropdown-item" @click="filterUsers('Alunos', 'student')">Alunos</a>
              <a class="dropdown-item" @click="filterUsers('Tutores', 'tutor')">Tutores</a>
              <a class="dropdown-item" @click="filterUsers('Professores', 'teacher')">Professores</a>
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex align-items-center justify-content-center total-users pt-3 mb-3">
        <span>{{ optionSelected || "Usuários" }} cadastrados: {{ usersTotalAmountBasedInRole[role] || '0' }}</span>
      </div>
      <div class="card-body">
        <UsersTable :users="usersData" @open="open" @confirmDelete="confirmDelete" />
        <div class="w-100 d-flex justify-content-center">
          <LoadContentButton v-if="usersData.length >= perPage && !noMoreUsers" @click="getUsers(true)" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useStore, mapGetters } from 'vuex';
import UsersTable from '@/components/tables/UsersTable.vue';
import {computed} from "vue";
import LoadContentButton from "../buttons/LoadContentButton.vue";

function debounce(func, wait) {
  let timeout;
  return function (...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, args), wait);
  };
}

export default {
  name: 'UsersCard',

  data() {
    return {
      store: useStore(),
      userWidth: computed(() => this.store.getters.getUserWidth),
      showIcons: null,
      search: '',
      showDropdown: false,
      role: 'users',
      optionSelected: 'Usuários',
      usersDataReference: computed(() => this.store.getters.getUsersData),
      usersTotalAmountBasedInRole: computed(() => this.store.getters.getUsersTotalAmountBasedInRole),
      usersData: [],
      isLoading: false,
      noMoreUsers: false,
      page: 1,
      perPage: 30,
    }
  },

  components: {
    LoadContentButton,
    UsersTable,
  },

  computed: {
    ...mapGetters({
      getToken: 'getToken',
      getType: 'getType',
      getUsersMetrics:'getUsersMetrics',
      fontMultiplier: 'acessibility/fontMultiplier'
    }),

    users() {
      return this.store.state.users.usersData;
    }
  },

  watch: {
    usersDataReference(newValue) {
      this.usersData = newValue
    },

    search: debounce(function () {
      this.page = 1;
      this.noMoreUsers = false
      this.getUsers();
    }, 500)
  },

  mounted() {
    this.usersData = this.usersDataReference
  },

  methods: {
    confirmDelete(userId) {
      if (window.confirm('Tem certeza que deseja excluir este usuário? Essa ação é permanente')) {
        this.deleteUser(userId)
      }
    },

    open(user) {
      this.$emit('open', user)
    },

    hideOrShowDropdown() {
      this.showDropdown = !this.showDropdown
    },

    filterUsers(text, option) {
      this.optionSelected = text;
      this.noMoreUsers = false
      this.role = option;
      this.showDropdown = false;
      this.page = 1;

      this.getUsers();
      this.$emit('changeOption', option)
    },

    getUserLimit() {
      switch (this.optionSelected) {
        case 'Usuários':
          return this.getUsersMetrics.total_users;
        case 'Alunos':
          return this.getUsersMetrics.total_students;
        case 'Tutores':
          return this.getUsersMetrics.total_tutors;
        default:
          return this.getUsersMetrics.total_users;
      }
    },

    async deleteUser(userId) {
      const payload = {
        userId: userId,
        userToken: this.getToken
      }

      try {
        await this.store.dispatch('deleteUser', payload);
      } catch (error) {
        console.log("Erro ao deletar usuário:", error);
      }
    },

    async getUsers(incrementWithOldUsers) {
      if (this.isLoading) {
        return;
      }

      try {
        const oldUsers = this.usersData
        this.isLoading = true;
        this.store.dispatch('skeleton/setLoadingState', { key: 'usersTable', value: true })

        const payload = {
          data: {
            search: this.search,
            role: this.role,
            userResponsible: this.userResponsible,
            page: this.page,
            perPage: this.perPage,
            include: 'avatar'
          },
          userToken: this.getToken
        }

        const response = await this.store.dispatch('getUsers', payload)
        if (response.length === 0) {
          this.noMoreUsers = true;
          this.usersData = oldUsers
          this.store.dispatch('toastfy/activeErrorNotification', { text: "Todos os usarios já foram listados"})
          return;
        }
        this.page += 1;

        if (incrementWithOldUsers) {
          this.usersData = [...oldUsers, ...response]
          console.log("Final Users: ", this.usersData)
        }
      } catch (error) {
        console.log("Erro ao obter usuários:", error)
      } finally {
        this.isLoading = false;
        this.store.dispatch('skeleton/setLoadingState', { key: 'usersTable', value: false })
      }
    },
  }
}
</script>

<style scoped>
.card {
  flex-grow: 1;
}

.card-body {
  overflow-y: auto;
}

.card-header {
  background-color: var(--blue-4);
  border: none;
}

.table {
  --bs-table-color: var(--gray-1);
  --bs-table-border-color: var(--blue-4);
}

.thead-light {
  background-color: var(--gray-4);
}

.search-group {
  margin-bottom: 40px;
}

.input-group {
  font-size: calc(10px * var(--font-scale));
  width: 100%;
  height: 30px;
}

.form-control {
  border: none;
  background-color: var(--blue-4);
  box-shadow: none;

  &:active {
    box-shadow: none;
  }

  &:focus {
    box-shadow: none;
    background-color: var(--blue-4);
  }
}

.btn-search {
  height: 30px;
  background-color: var(--blue-4);
  border: none;
  color: var(--gray-3);
  width: 2rem;

  &:hover {
    background-color: var(--blue-4);
    border: none;
    color: var(--gray-1);
    transform: scale(1.2);
    transition: transform 0.3s ease;
  }

  &:active {
    background-color: var(--blue-4);
    border: none;
  }

  &:focus {
    background-color: var(--blue-4);
    border: none;
  }
}

.bi {
  cursor: pointer;
}

.edit-icon:hover {
  color: var(--blue-5);
}

.delete-icon:hover {
  color: red;
}

.dropdown-toggle {
  border: none;
  color: var(--gray-2);
  background-color: var(--blue-4);

  &:hover {
    color: var(--blue-5);
    background-color: var(--blue-4);
  }
}

.dropdown-menu {
  top: 2.3rem;
  right: 0;
  border: none;
  background-color: var(--blue-4);
}

.dropdown-item:hover {
  color: var(--blue-5);
}

.total-users {
  font-size: calc(16px * var(--font-scale));
  color: var(--gray-2);
}
</style>